import React, { useEffect } from 'react';
import { func } from 'prop-types';

import { isNumber, formatCurrency } from '@ajaibid/utils';
import { colors, Row, Col, Button, Typography } from '@ajaibid/components';
import SvgIcon from 'Component/SvgIcon';
import stockService from '@services/stock';

import { useStockBuySellContext } from '../../../hooks';
import { styFormBpInsufficientRow } from '../../../style';
import { useEventTracker } from '../../../../tracker';

const SummaryAvailableLot = (props) => {
  const { onClickAvailableLotInfo } = props;

  const { code, formAction, dispatch, isAccountRegular, isAccountDT, isAccountMT, maxSell } =
    useStockBuySellContext();

  const { data: stockPortfolio } = stockService.account.regular.portfolio.usePortfolioByCode(code);
  const { data: dtPortfolio } = stockService.account.dt.portfolio.useDtPortfolioByCode(code);
  const { data: mtPortfolio } = stockService.account.mt.portfolio.useMtPortfolioByCode(code);

  const isPortfolioEmpty = isNumber(maxSell.value) && maxSell.value <= 0;
  // If maxSell is lower than the lot in portfolio, that means there is a frozen lot (due to open order or TP/SL)
  const hasFrozenPortfolio = maxSell.value < stockPortfolio?.lot;
  const hasFrozenPortfolioDT = maxSell.value < dtPortfolio?.lot;
  const hasFrozenPortfolioMT = maxSell.value < mtPortfolio?.lot;

  const { eventViewInsufficientSell, eventClickInsufficientSell } = useEventTracker();

  useEffect(() => {
    if (isPortfolioEmpty) {
      eventViewInsufficientSell();
    }
  }, [isPortfolioEmpty]);

  const handleCTA = () => {
    dispatch({ type: formAction.CHANGE_ORDER_SIDE, code, payload: 'BUY' });
    eventClickInsufficientSell();
  };

  return (
    <>
      <Row noGutters align="between">
        <Col size="auto" style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
          <Typography type="body" color={colors.NEUTRAL_7} margin={0}>
            Lot Tersedia
          </Typography>
          <SvgIcon
            name="information"
            height={16}
            width={16}
            color={colors.NEUTRAL_7}
            onClick={onClickAvailableLotInfo}
            data-testid="btn-availableLotInfo"
          />
        </Col>
        <Col size="auto">
          <Typography type="body" margin={0} data-testid="txt-availableLot">
            {formatCurrency(maxSell.label, 'Lot')}
          </Typography>
        </Col>
      </Row>
      <div
        className={styFormBpInsufficientRow({ show: isPortfolioEmpty })}
        data-testid="div-lotInsufficient"
      >
        <Row noGutters align="between">
          <Col size="auto">
            <Typography type="alert" alertType="error" margin={0} data-testid="txt-lotInsufficient">
              {isAccountRegular &&
                !hasFrozenPortfolio &&
                'Kamu belum memiliki saham ini di portfoliomu.'}
              {isAccountRegular &&
                hasFrozenPortfolio &&
                `Lot Tersedia tidak mencukupi. Pastikan tidak ada order jual ${code} lainnya yang sedang berjalan.`}
              {isAccountDT &&
                !hasFrozenPortfolioDT &&
                'Kamu belum memiliki saham ini dalam Day Trading di portfoliomu.'}
              {isAccountDT &&
                hasFrozenPortfolioDT &&
                `Lot Tersedia tidak mencukupi. Pastikan tidak ada order jual ${code} lainnya yang sedang berjalan.`}
              {isAccountMT &&
                !hasFrozenPortfolioMT &&
                'Kamu belum memiliki saham ini dalam Margin Trading di portfoliomu.'}
              {isAccountMT &&
                hasFrozenPortfolioMT &&
                `Lot Tersedia tidak mencukupi. Pastikan tidak ada order jual ${code} lainnya yang sedang berjalan.`}
            </Typography>
          </Col>
          <Col size="auto">
            <Button variant="secondary" onClick={handleCTA} data-testid="btn-lotInsufficient">
              Beli
            </Button>
          </Col>
        </Row>
      </div>
    </>
  );
};

SummaryAvailableLot.propTypes = {
  onClickAvailableLotInfo: func,
};

SummaryAvailableLot.defaultProps = {
  onClickAvailableLotInfo: () => {},
};

export default SummaryAvailableLot;
